export default __webpack_public_path__ + "static/media/mt4_win.f666cb48.png";